import { useRecoilValue } from 'recoil';
import { userInformationAtom } from '../../../Services/_states';

/**
 * Matches legacy Intervene superuser checks (OrganisationBotSelectionModal, etc.).
 */
export default function useInterveneSuperAdmin() {
  const userInfo = useRecoilValue(userInformationAtom);
  return Boolean(userInfo?.is_superuser);
}
